import type { FunctionComponent } from 'react'

import { FlowSelect } from '../../Budget/budget.styled'
import { DebtRecordRevampedType } from '../types/debtOverviewApi.types'
import { useDebtTypeText } from './debtOverviewUtilities'

export const DebtTypeSelect: FunctionComponent<{
	value: DebtRecordRevampedType | null
	onChange: (value: DebtRecordRevampedType) => void
}> = ({ value, onChange }) => {
	const debtTypeText = useDebtTypeText()
	return (
		<FlowSelect
			value={value}
			disableUnderline
			values={Object.values(DebtRecordRevampedType).map((_value) => ({
				value: _value,
				displayValue: <span>{debtTypeText(_value)}</span>,
			}))}
			onChange={(x) => onChange(x.target.value as DebtRecordRevampedType)}
		/>
	)
}
